import { render, staticRenderFns } from "./ComboOfferSale.vue?vue&type=template&id=4ef96ed5"
import script from "./ComboOfferSale.vue?vue&type=script&lang=js"
export * from "./ComboOfferSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports